module.exports = __webpack_public_path__ + "img/worldcup-bg.8f6012bf.webp";